var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('button',{class:[_vm.isChange ? 'active' : 'noactive'],on:{"click":_vm.handleLogin}},[_vm._v(" Sign in ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }